import type { Theme } from '@mui/material/styles';
import { alpha } from '@mui/material/styles';

/** Slack の自分宛メンションに近い黄〜オレンジ */
const SLACK_MENTION_GOLD = '#ffcc33';
const SLACK_MENTION_TEXT = '#5c4a00';

/** 本文内・他人へのメンション（従来の青系） */
export function bulletinMentionOtherSpanSx(theme: Theme) {
  return {
    color: 'info.main' as const,
    fontWeight: 600,
    bgcolor: alpha(theme.palette.info.main, 0.12),
    px: 0.25,
    borderRadius: 0.5,
  };
}

/** 本文内・自分へのメンション（Slack 風） */
export function bulletinMentionSelfSpanSx() {
  return {
    color: SLACK_MENTION_TEXT,
    fontWeight: 600,
    bgcolor: alpha(SLACK_MENTION_GOLD, 0.42),
    px: 0.25,
    borderRadius: 0.5,
  };
}

/** 一覧・自分がメンションされている行の背景 */
export function bulletinMentionedRowSurfaceSx(hover: boolean) {
  return {
    bgcolor: alpha(SLACK_MENTION_GOLD, hover ? 0.22 : 0.14),
  };
}
